export default __webpack_public_path__ + "static/media/slides_uninformed_search.a2d7cd2a.pdf";